import { InjectionToken } from '@angular/core';

export const SOFTLINE_FEATURE_AUTHORIZATION = 'authorization';
export const SOFTLINE_CONFIG_AUTHORIZATION_DENIED_ROUTE = new InjectionToken<
  string | undefined
>('AUTHORIZATION_DENIED_ROUTE', {
  factory: () => '',
});
